export async function load(parameter, callback) {
	let file = parameter.file;
	if (!file) {
		console.error("Error: 'file' parameter is required");
		return;
	}

	try {
		// Usando BACKTICKS para que funcione la variable ${file}
		const response = await fetch(`./server/php/queries/entityFunction/${file}.php`, {
			method: "POST",
			body: JSON.stringify(parameter), // Es buena práctica enviar los parámetros en el body si es POST
			headers: { 'Content-Type': 'application/json' },
			credentials: 'same-origin'
		});

		if (!response.ok) throw new Error(`Error en la red: ${response.status}`);

		const resultados = await response.json();
		callback(resultados); // Ejecuta el callback con éxito
	} catch (err) {
		console.error("Error en la petición:", err);
		callback([]); // Retorna un array vacío para evitar que falle el frontend
	}
}